import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { RawSearchResponse, SearchRequestParams, SearchResponse, parseSearchResponse } from './global-search-api.model';

export const EKS_SEARCH_API_URL = '/eks/search-service/v1/search';

@Injectable({ providedIn: 'root' })
export class GlobalSearchApiService {
  private readonly http = inject(HttpClient);

  search(params: SearchRequestParams): Observable<SearchResponse> {
    let httpParams = new HttpParams()
      .set('query', params.query)
      .set('archived', params.archived)
      .set('deleted', params.deleted);

    if (params.pageIndex != null) {
      httpParams = httpParams.set('pageIndex', params.pageIndex);
    }
    if (params.pageSize != null) {
      httpParams = httpParams.set('pageSize', params.pageSize);
    }

    return this.http.get<RawSearchResponse>(EKS_SEARCH_API_URL, { params: httpParams }).pipe(map(parseSearchResponse));
  }
}
